var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import { CFFieldElements } from '../../components';
import { commonAttrs } from '../../utils';
import { FieldDecorator, FieldValidationBadge } from './components';
export const CFTextField = (_a) => {
    var { disabled = false, fieldSize = 'md', iconLeft, iconRight, id, maskInput = false, name, nativeFieldProps, onChange, placeholder, rows, showValidationBadge = true, type = 'text', validationState = 'default', value = '' } = _a, rest = __rest(_a, ["disabled", "fieldSize", "iconLeft", "iconRight", "id", "maskInput", "name", "nativeFieldProps", "onChange", "placeholder", "rows", "showValidationBadge", "type", "validationState", "value"]);
    const [focused, setFocused] = useState(false);
    const [internalValue, setInternalValue] = useState(value);
    const { FieldControlInput, FieldControlTextarea, FieldRoot, FieldValue, FieldWrapper, } = CFFieldElements;
    const onFieldBlur = (event) => {
        setFocused(false);
        if (nativeFieldProps === null || nativeFieldProps === void 0 ? void 0 : nativeFieldProps.onBlur)
            nativeFieldProps.onBlur(event);
    };
    const onFieldChange = (event) => {
        setInternalValue(event.currentTarget.value);
        if (onChange)
            onChange(event.currentTarget.value, { event });
    };
    const onFieldFocus = (event) => {
        setFocused(true);
        if (nativeFieldProps === null || nativeFieldProps === void 0 ? void 0 : nativeFieldProps.onFocus)
            nativeFieldProps.onFocus(event);
    };
    useEffect(() => {
        if (value !== internalValue)
            setInternalValue(value);
    }, [value]);
    const FieldControl = rows && rows > 1 ? FieldControlTextarea : FieldControlInput;
    return (React.createElement(FieldRoot, Object.assign({ disabled: disabled, fieldSize: fieldSize, focused: focused, rows: rows, validationState: validationState }, commonAttrs(rest)),
        React.createElement(FieldControl, Object.assign({ disabled: disabled, fieldSize: fieldSize, focused: focused, hasIconLeft: !!iconLeft, hasIconRight: !!iconRight, name: name, onBlur: onFieldBlur, onChange: onFieldChange, onFocus: onFieldFocus, placeholder: placeholder, rows: rows, type: maskInput ? 'password' : type, showValidationBadge: showValidationBadge, validationState: validationState, value: internalValue, 
            // Native props
            id: id, "data-testid": rest.testID ? `${rest.testID}-input-field` : undefined }, nativeFieldProps)),
        React.createElement(FieldWrapper, { fieldSize: fieldSize },
            React.createElement(FieldDecorator, { disabled: disabled, fieldSize: fieldSize, icon: iconLeft }),
            React.createElement(FieldValue, null, " "),
            React.createElement(FieldValidationBadge, { disabled: disabled, fieldSize: fieldSize, showValidationBadge: showValidationBadge, validationState: validationState }),
            React.createElement(FieldDecorator, { disabled: disabled, fieldSize: fieldSize, icon: iconRight }))));
};
